export default "__VITE_ASSET__yeGXRiTg__"